// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"0187f47b15c4955da94a","147":"8d40f670f6921fa6748f","251":"d611824d8c0be29ab804","265":"88cbfd9a071139a17262","352":"4764c8571cce9dd08ba1"}[chunkId] + ".js";
};